
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/retail",
      function () {
        return require("private-next-pages/solutions/retail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/retail"])
      });
    }
  